import React from 'react'
import { ROUTES, ROUTE_NAMES } from '../constants/routes'

// Lazy-loaded public pages
const Login = React.lazy(() => import('../views/pages/login/Login'))
const ForgotPassword = React.lazy(() => import('../views/pages/forgotpassword/ForgotPassword'))
const ResetPassword = React.lazy(() => import('../views/pages/resetPassword/ResetPassword'))
const Page404 = React.lazy(() => import('../views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('../views/pages/page500/Page500'))

const publicRoutes = [
  { path: ROUTES.LOGIN, element: Login, name: ROUTE_NAMES.LOGIN },
  { path: ROUTES.FORGOT_PASSWORD, element: ForgotPassword, name: ROUTE_NAMES.FORGOT_PASSWORD },
  { path: ROUTES.RESET_PASSWORD, element: ResetPassword, name: ROUTE_NAMES.RESET_PASSWORD },
  { path: ROUTES.PAGE_404, element: Page404, name: ROUTE_NAMES.PAGE_404 },
  { path: ROUTES.PAGE_500, element: Page500, name: ROUTE_NAMES.PAGE_500 },
]

export default publicRoutes
